/**
 * 本地接口代理
 */

const unitePre = '/boss';
// const unitePre = '';

const envList = ['dev', 'sit', 'product'];

const system = [
  {
    name: '灵格低代码平台',
    appId: '100001',
  },
];

const proxyList = [
  {
    target: 'http://api.linggekj.com/',
    // target: 'http://api-linggekj.com/', // 不用写死，统一走 {env} 占位符
    sysList: [
      '/infra-certificate',
      '/infra-integration',
      '/infra-authority',
      '/infra-message',
      '/demo-lowcode',
      '/infra-metadata',
      '/infra-workflow',
      '/infra-impexp',
      '/infra-sign',
      '/infra-ruleengine',
      '/lingbo-crm',
      '/lingbo-funds',
      '/lingbo-data',
      '/lingbo-console',
      '/lingbo-doctor'
    ],
  },
  // 可以继续添加更多配置 ...
];

const getProxy = () => {
  const data = {};

  envList.forEach((env) => {
    proxyList.forEach((p) => {
      p.sysList.forEach((sys) => {
        const curKey = `${unitePre}${sys}`;

        // 判断 target
        let curTarget;
        // if (env === 'product') {
        //   curTarget = 'http://api.linggekj.com/';
        // } else {
        //   curTarget = p.target.replace('{env}', env);
        // }
        //  curTarget = 'http://lingbo-api-dev.linggekj.com/';
         curTarget = 'http://api.linggekj.com/';
        const rule = `^${curKey}`;

        // 特殊情况 pathRewrite 规则
        if (['/dev-carrier', '/legacy-finance-collection'].includes(sys)) {
          data[curKey] = {
            target: curTarget,
            secure: false,
            logLevel: 'debug',
            pathRewrite: {
              [rule]: '',
            },
          };
        } else {
          data[curKey] = {
            target: curTarget,
            secure: false,
            logLevel: 'debug',
            pathRewrite: {
              [rule]: sys,
            },
          };
        }
      });
    });
  });

  return data;
};

// 素材 CDN 代理：直播子应用（infra-web-streaming）的 hls.js 播放器在本地开发时
// 把 cdn-test.lingbo.tv 的 m3u8/ts 地址改写成同源 /cdn-proxy，浏览器请求会落到
// 主应用 origin 上，因此代理必须配置在【主应用】（本文件），否则返回 SPA HTML 导致 m3u8 解析失败
const cdnProxy = {
  '/cdn-proxy': {
    target: 'https://cdn-test.lingbo.tv',
    changeOrigin: true,
    secure: false,
    logLevel: 'debug',
    pathRewrite: {
      '^/cdn-proxy': '',
    },
  },
};

const proxyConfig = {
  ...getProxy(),
  ...cdnProxy,
};

module.exports = {
  proxyConfig,
  envList,
  system,
};
